<template>
    <div class="page-wrapper" ref="six">
        <!-- 顶部图片 -->
        <div class="movie-box banner-wrapper">
            <img class="page-image" src="@assets/images/funv-top-banner.jpg" />
        </div>

        <div class="movie-box festivalList-wrapper">
            <!-- nav -->
            <div class="movie-box acea-row row-middle nav-wrapper" ref="navfn">
                <FestivalNav v-if="!mounting" @checkNav="checkNav" :isless="true" :boxStyle="boxStyle" :liStyle="liStyle" :current="current" :navList="navList"></FestivalNav>
            </div>

            <div class="movie-box acea-row row-middle nav-wrapper mounting" v-show="mounting">
                <FestivalNav @checkNav="checkNav" :isless="true" :boxStyle="boxStyle" :liStyle="liStyle" :current="current" :navList="navList"></FestivalNav>
            </div>

            <!-- 模板 -->
            <div class="movie-box" v-for="(item, ind) in list" :key="ind" :ref="'modulSix'+item.id">
                <FestivalModul :pinjie="true" :cardStyle="cardStyle" :bottomPrice="bottomPrice" :cardOneImageStyle="cardOneImageStyle" :topImageStyle="topImageStyle" :cardOne="cardOneStyle" :bottomImageStyle="bottomImageStyle" :titleInfo="item.titleInfo" :imgStyle="imgStyle" :listStyle="listStyle" :festivalName="festivalName" :list="item.list"></FestivalModul>
            </div>

            <!-- 底部图片 -->
            <div class="movie-box" style="margin-top:0.62rem;">
                <img class="page-image bottom-click" @click="goTo" src="@assets/images/funv-bottom-goback.png" />
                <!-- <img class="page-image bottom-click" @click="goPage" src="" /> -->
                <img class="page-image" src="@assets/images/funv-bottom-image.jpg" />
            </div>
        </div>
    </div>
</template>

<script>
import FestivalModul from "@components/FestivalModul.vue";
import FestivalNav from "@components/FestivalNav.vue";
import debounce from "lodash.debounce";
export default {
    name: "SanBaFuNvJie",
    components: {
        FestivalModul,
        FestivalNav
    },
    data: function () {
        return {
            mounting: false,
            festivalName: 4,//这个要改-关于ref的要改
            cardOneStyle: {
                background: "#fff",
                "border-radius": "0.2rem"
            },
            cardOneImageStyle: {
                padding: "0",
                width: "2.98rem",
                height: "2.98rem"
            },
            topImageStyle: {
            },
            bottomImageStyle: {
            },
            listStyle: {
                background: "#FFE3E5",
                padding:"0.2rem 0.26rem",
                "margin-top": "-0.26rem",
                "border-radius":"0 0 .2rem .2rem",
                border: "2px solid #FFEEF4",  
                "box-shadow": "inset 0px 0px 18px 0px rgba(255,138,134,0.75)"
            },
            boxStyle: {
                "justify-content": "center"
            },
            liStyle: {
                width: "2.3rem"
            },
            imgStyle: {
                "height": "2rem",
                "margin": "0.58rem 0 0 0"
            },
            bottomPrice: {
                dt: {
                    "line-height": "0.36rem",
                    "margin-top": "0.05rem"
                },
                iconStyle: {
                    display: "none"
                },
                priceStyle: {
                    "font-color":"#FF2727 !important",
                    "font-weight": 500
                },
                src: require("@assets/images/funv-icon.png"),
                imgStyle: {
                    width: "0.4rem",
                    height: "0.4rem"
                }
            },
            cardStyle: {
                "padding":"0.08rem",
                "min-height":"4.6rem"
            },
            navList: [
                {
                    id: 1,
                    img: require("@assets/images/funv-nav1.png"),
                    checkImg: require("@assets/images/funv-navc1.png")
                }, {
                    id: 2,
                    img: require("@assets/images/funv-nav2.png"),
                    checkImg: require("@assets/images/funv-navc2.png")
                }, {
                    id: 3,
                    img: require("@assets/images/funv-nav3.png"),
                    checkImg: require("@assets/images/funv-navc3.png")
                }
            ],
            list: [
                {
                    id: 1,
                    titleInfo: require("@assets/images/funv-title1.png"),
                    list: [
                    {
                        image:"https://image.dongfangfuli.com/supplier/ab0007500566458d8b4664c3378064a5.jpg",
                        title:"摩飞电器（Morphyrichards）升降养生壶MR6088 白色",
                        price:608,
                        id:4727
                    },
                    {
                        image:"https://image.dongfangfuli.com/mall/upload/image_temp/2020-05/5b6b55d4-74d2-4bbc-b950-3daab2fd214c.jpg",
                        title:"摩飞（MORPHY RICHARDS）便携式果汁机 多功能小型家用料理机 MR9500",
                        price:224,
                        id:5203
                    },
                    {
                        image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/acd2e202210261844151280.jpg",
                        title:"摩飞（MORPHY RICHARDS）便携榨汁机 充电式小型旅行果汁机 MR9600（蓝色）",
                        price:175,
                        id:5205
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2021/05/20210510/cd5385aafddcb8a4368564faca45c414.jpg",
                        title:"摩飞 便携电水壶 MR6080 白色",
                        price:258,
                        id:6668,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2021/05/20210510/729414ced96a5b8defcaa378f3d8d8f7.jpg",
                        title:"skg 按摩类小电器 K5-2（云镜白）",
                        price:458,
                        id:6682,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2021/05/20210511/9cd8466f971e854bf18c85f824e268bc.jpg",
                        title:"大宇(DAEWOO)超声波清洗机C1（颜色随机）",
                        price:271,
                        id:6703,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2021/05/20210513/40e3c9d98414bd91850c8b43c22b3285.jpg",
                        title:"素士冲牙器W1",
                        price:292,
                        id:6902,
                    },
                    {
                        image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-07/8ed3c67359667413cd9c9f8294594552.jpg",
                        title:"美的手持吸尘器 SN7",
                        price:298,
                        id:17747,
                    },
                    {
                        image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-07/08f9de58b11c209853e8b9f5b04521d9.jpg",
                        title:"SKG Mini筋膜枪  F5  白色",
                        price:486,
                        id:19168,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2021/07/20210708/06924df1515ffcb705a7f14f631f7548.jpg",
                        title:"蕉下-2021年纭际系列贝壳防晒帽 颜色随机",
                        price:153,
                        id:21656,
                    },
                    {
                        image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/ac52f9fc527f94f0c3f08895806cfb6b.jpg",
                        title:"美的（Midea）微波炉家用转盘式快捷加热M1201A白色DIY（M100）企业采购",
                        price:451,
                        id:169822,
                    },
                    {
                        image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/dced5f73406aabd365fe3f6717589bb6.jpg",
                        title:"美的（Midea）除螨仪MT3有线手持床上家用吸尘器冰莹粉紫外线杀菌除螨",
                        price:299,
                        id:169829,
                    },
                    {
                        image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/63d73e12e955e43bf23802cdb95c49ec.jpg",
                        title:"GIC颈椎按摩仪小时光吊坠按摩仪多功能肩颈部按摩缓圧神器颈椎按摩器送礼七夕礼盒流光粉",
                        price:313,
                        id:170038,
                    },
                    {
                        image:"http://app.qianbaishikeji.com/qbs_server/upload/resimgs/1/9868/77625/img300.jpg",
                        title:"美的自动感应洗手机免洗款 OXS-2800",
                        price:97,
                        id:176825,
                    },
                    {
                        image:"https://image.dongfangfuli.com/supplier/3eeb38f6358344599656d6236daa2ab8.png",
                        title:"摩飞电器（Morphyrichards）蒸汽挂烫机MR2030（白色）",
                        price:328,
                        id:177336,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/a10baf987272e2776a1c5ca39e85a347.jpg",
                        title:"翼眠无压枕-波浪款",
                        price:257,
                        id:177532,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/0dc2bff0da7d53195d3a5d1273c657f4.jpg",
                        title:"素士复古负离子电吹风RH1 原野绿 标准版 （无按摩风嘴）",
                        price:306,
                        id:177641,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220512/1245a011d2e291157c370caa072f3fd9.jpg",
                        title:"蕉下-冰薄系列披肩防晒服（均码）（颜色随机",
                        price:176,
                        id:178034,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220519/ba3464c08604075f898741ea97861cec.jpg",
                        title:"九阳破壁机L12-P125",
                        price:354,
                        id:178523,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/b5d9e0afa351829420a37a06fea70e2b.jpg",
                        title:"卡特马克30cm八角炒锅",
                        price:250,
                        id:178597,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/151d3c87bc782a063330ddd48e7b5221.jpg",
                        title:"卡特马克加固四件套",
                        price:83,
                        id:178624,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220520/6d7b19869422de07fe76471a8d840f94.jpg",
                        title:"素士净宠声波电动牙刷 D3 粉色 特别版",
                        price:285,
                        id:178635,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/06/20220607/52d6c53a5e299820b07a82ae74a96ab8.jpg",
                        title:"大宇（DAEWOO）挂烫机家用手持小星斗熨烫机 蒸汽电熨斗 旅游出差便携式小型除菌自清洁烫衣机HI-036 星黛紫",
                        price:403,
                        id:179600,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/06/20220623/b913bb140c922047e72ed67e59d37f43.jpg",
                        title:"英国摩飞榨汁杯便携大容量运动果汁杯补水 无线充电户外榨汁桶榨汁机胖吨桶MR9802 蓝色",
                        price:247,
                        id:179843,
                    },
                    {
                        image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d6baf202210241248039031.jpeg",
                        title:"摩飞电器（Morphyrichards） 多层冰块模具制冰快速脱模家用冰箱制冰双层真空锁温保冷桶 MR1105",
                        price:201,
                        id:179987,
                    },
                    {
                        image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d9d5a202210241142557257.jpeg",
                        title:"摩飞（Morphyrichards）空气炸锅 家用8L大容量可视双炸篮多功能空气炸烤箱 炸薯条鸡翅机MR8100 绿色",
                        price:729,
                        id:179995,
                    },
                    {
                        image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/18aee202210241119242163.jpeg",
                        title:"摩飞（Morphyrichards）便携养生壶迷你煮茶器烧水壶养生杯小型办公室家用多功能煮茶壶热水壶MR6086 绿色",
                        price:278,
                        id:180000,
                    },
                    {
                        image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/f920d202210131255542735.jpeg",
                        title:"摩飞除螨仪MR3100",
                        price:499,
                        id:180037,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/e5cab6a3f13213cfa5d3b92668aa5378.jpg",
                        title:"摩飞无雾加湿器MR2081",
                        price:358,
                        id:180046,
                    },
                    {
                        image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/6461d825ddea356bc1894daaa8f404ce.jpg",
                        title:"摩飞艺术电水壶MR7076A  白色",
                        price:360,
                        id:180061,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a146e202212261430186437.jpg",
                    title:"康宁暖烤一体全景可视化空气炸盘CB-NKYTKQZG/KZ",
                    price:660,
                    id:180121,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/7aef8202212261420281329.jpg",
                    title:"康宁EKCO琥珀色玻璃保鲜盒2件组EK-BXH-2Y-KZ",
                    price:99,
                    id:180126,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d9a41202212261411255310.jpg",
                    title:"康宁琥珀色餐具8件组A（4个小碗2个深盘2个浅盘）VS-AMR8A/KZ",
                    price:299,
                    id:180131,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/3f5b6202211111647335347.jpeg",
                    title:"康宁晶钻系列透明锅VS-35-DI/E/CN  --3.5L",
                    price:415,
                    id:180144,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/20c4120221111142236639.jpeg",
                    title:"VSP-15-TR康宁晶炫系列透明锅--1.5L单柄",
                    price:313,
                    id:180149,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a2938202212231403076537.jpg",
                    title:" 东菱（Donlim） 多功能蒸炖锅 DL-9009",
                    price:769,
                    id:180183,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/85ea3202211111459037558.jpeg",
                    title:"东菱Donlim 乐萃杯 冷泡茶壶DL-9003",
                    price:244,
                    id:180186,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/ed025202211111451091067.jpeg",
                    title:"东菱（Donlim） 胶囊果蔬清洗机DL-001",
                    price:229,
                    id:180189,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/9ea18202211101444325536.jpeg",
                    title:"东菱 Donlim 多功能电热饭盒DL-1223（晨曦黄）",
                    price:318,
                    id:180192,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/c6411202212281450092358.jpg",
                    title:"东菱（Donlim） 牙刷架消毒器 紫外线杀菌灯珠牙刷消毒智能感应牙刷收纳支架免打孔卫生间置物架 DL-1239静谧蓝",
                    price:253,
                    id:180202,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/1169c202212281436188669.jpg",
                    title:"东菱Donlim电水壶 便携式烧水壶 电热水杯家用 旅行烧水杯 小型冲奶防烫办公室养生保温杯 DL-B1棉云白",
                    price:214,
                    id:180209,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/48eef202212281544256268.jpg",
                    title:" 东菱（Donlim） 咖啡机家用半全自动意式浓缩办公室商用高压萃取蒸汽打奶泡机 性价比升级款DL-6400东菱（Donlim） 咖啡机家用半全自动意式浓缩办公室商用高压萃取蒸汽打奶泡机 性价比升级款DL-6400东菱（Donlim） 咖啡机家用半全自动意",
                    price:611,
                    id:180217,
                    },
                    {
                    image:"http://crmeb.xiaojiangwh.com/uploads/attach/2022/08/20220819/9c588c2322503cb8349478c5e14f8323.jpg",
                    title:"利仁（Liven） 电饼铛LPBC-87",
                    price:203,
                    id:180598,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/83a85202212231404203763.jpg",
                    title:"大宇抑菌蒸汽拖把SMOP01",
                    price:563,
                    id:180602,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/9db78202212231426433070.jpg",
                    title:"BRUNO 日本小胖墩电压力锅BRUNOBZK-YLG01家用小型高压锅风冷泄压全自动排气3L大容量智能压力煲电饭煲荼白灰",
                    price:583,
                    id:180604,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/cf14c202211111716339839.jpeg",
                    title:"利仁（Liven）电饼铛家用双面加热加深烤盘双面可拆 双盘可拆洗LPBC-9",
                    price:458,
                    id:180618,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/e1885202302141443495646.jpg",
                    title:"荣泰K32颈椎 肩膀按摩器家用车载充电款按摩披肩缓解肩部疲劳腰部按摩枕背部腿部按摩仪揉捏热敷推拿",
                    price:492,
                    id:180720,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/234c5202210211424319059.png",
                    title:"荣泰 Q20 小魔爪头部按摩器",
                    price:260,
                    id:180721,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/de062202302141441136984.jpg",
                    title:"skg眼部按摩仪 E4Pro穴位热敷按摩器按摩仪 可视化护眼仪 睡眠眼罩 送礼生日 情人节礼物",
                    price:542,
                    id:180722,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/f9a5c202302141437524705.jpg",
                    title:"SKG 腰部按摩器 智能按摩腰带多功能揉捏加热无线热敷按摩仪生日新年情人节礼物送老婆男女友长辈礼品 【腰部榜单NO.1】超薄双脉冲W7",
                    price:486,
                    id:180724,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/cf315202302141430202854.jpg",
                    title:"【薛之谦联名款】漫步者（EDIFIER）Q2真无线蓝牙耳机耳机音乐运动耳机降噪半入耳超长待机",
                    price:174,
                    id:180725,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/7da8420230214142838333.jpg",
                    title:"富安娜 FUANNA 家纺 203*229cm 丽妍-蚕丝夏被",
                    price:558,
                    id:180726,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/1e314202211111510586649.jpeg",
                    title:"富安娜秋四季款棉四件套花容月貌 203*229",
                    price:533,
                    id:180727,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/307ac202302141426124639.jpg",
                    title:"水星家纺 DH茜影灵动四件套 200*230cm",
                    price:435,
                    id:180728,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/0e74d202302141422293354.jpg",
                    title:"凯诗捷（KASJ） 泡脚桶足浴盆全自动按摩洗脚盆电动加热泡脚盆足浴桶送爸妈情人节生日礼物K2 ",
                    price:513,
                    id:180729,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a4218202211111951156798.jpeg",
                    title:"日本BRUNO 日本空气炸锅BZK-KZ03 -GR",
                    price:431,
                    id:180730,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/5223d202302141419182728.jpg",
                    title:" BRUNO日本迷你电饭煲1.2L小型2人智能触屏预约小饭煲 BZK-D02",
                    price:264,
                    id:180731,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/f166f202210251151404791.jpeg",
                    title:"美的扫地机器人 R2TCN",
                    price:499,
                    id:180732,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/c110e202302141416522969.jpg",
                    title:"美的（Midea）美的（Midea） 电饭煲MB-AFB3061R家用多功能电饭锅 3L容量1-4人使用智能预约 AFB3061R(3L)",
                    price:292,
                    id:180733,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/3d797202302141414182376.jpg",
                    title:"蕉下-双层三折小黑伞 颜色随机",
                    price:194,
                    id:180734,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/5ef18202302141404099863.jpg",
                    title:"摩飞电器（Morphyrichards）英国摩飞电器 车载吸尘器 无线便携手持大吸力桌面充电小型沙发臭氧杀菌除菌除味净化汽车家电 MR3936 白色",
                    price:256,
                    id:180735,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/bd582202302141400238255.jpg",
                    title:"摩飞多功能锅MR9088 颜色随机",
                    price:688,
                    id:180736,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/479b3202302141357114831.jpg",
                    title:"卡特马克鲸鱼迷你小奶锅宝宝婴儿童辅食锅蒸煮牛奶汤不粘锅泡面雪平锅16cm明火电磁炉通用 煎锅+奶锅（珊瑚粉）",
                    price:208,
                    id:180737,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/58c57202302141354434997.jpg",
                    title:"九阳（Joyoung）电饭煲 电饭锅 家用多智能一键低糖饭电饭煲 4L容量 F-40FY750",
                    price:375,
                    id:180738,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/fbc9c202302141350458668.jpg",
                    title:"九阳破壁机L12-Y3(含干磨杯）",
                    price:1139,
                    id:180739,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/77b87202302141338236942.jpg",
                    title:"素士HS01玉米夹发棒  绿色",
                    price:264,
                    id:180740,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/bec97202302141335488877.jpg",
                    title:"七次方功夫泡茶机TM141",
                    price:521,
                    id:180741,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/67e71202302141143567812.png",
                    title:"Moido小活泉花洒M22陌冬花洒",
                    price:306,
                    id:180742,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/ab73b202302141137195391.jpg",
                    title:"雷瓦（RIWA）蛋蛋卷发棒大卷蛋糕烫发水波浪纹懒人蛋卷棒神器泡面头夹板负离子Z7-ION",
                    price:165,
                    id:180743,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/c984f202302141128115705.jpg",
                    title:"艾优（Apiyoo）化妆镜带灯led智能美妆镜补光梳妆镜 宝可梦联名 粉色",
                    price:181,
                    id:180744,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/f7a56202302141125425392.jpg",
                    title:"ApiYooApiYoo apiyoo艾优P8A成人大理石电动牙刷 白色",
                    price:222,
                    id:180745,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/71bcd202302141122191419.jpg",
                    title:"佑美（YOU MEI）  全民健身礼盒YM-04",
                    price:125,
                    id:180746,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/dea7c202302141116506088.jpg",
                    title:"佑美（YOU MEI）计数跳绳（无绳球大球/钢丝绳/带负重） TS30  粉色",
                    price:67,
                    id:180747,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/ae286202302141114411759.jpg",
                    title:"佑美（YOU MEI） 佑美星座瑜伽垫YJD002 粉色",
                    price:90,
                    id:180748,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d6f56202302141529573014.jpg",
                    title:"罗莱 春朝夏影 40支全棉四件套",
                    price:488,
                    id:180749,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/54660202302141459413882.jpg",
                    title:"左点智能坐灸仪ZD-ZJ5",
                    price:361,
                    id:180750,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/843cd202302161745168621.jpg",
                    title:"K-SKIN 金稻KD883B暖宫带【数据线】【石墨烯加热】",
                    price:157,
                    id:180761,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/2b432202302161738374992.jpg",
                    title:"K-SKIN 金稻KD8023超声波毛孔清洁器（粉色/白色）",
                    price:111,
                    id:180767,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/288c7202302161729594942.jpg",
                    title:"K-SKIN 金稻KD2332 彩光蒸脸器",
                    price:228,
                    id:180769,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/9293620230216172621639.jpg",
                    title:"K-SKIN 金稻KD88冷喷补水仪",
                    price:85,
                    id:180770,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/e904620221110111519601.jpeg",
                    title:"神田幻彩系列 18cm 嫩桃粉套装(含锅盖)",
                    price:125,
                    id:180824,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/49d72202302161743083541.jpg",
                    title:"K-SKIN 金稻KD506A冰点激光脱毛仪 【99万发】绿色",
                    price:859,
                    id:180837,
                    }
                    ]
                }, 
                {
                    id: 2,
                    titleInfo: require("@assets/images/funv-title2.png"),
                    list: [
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2021/04/20210415/ebfdf6b5606155e61bf2bf619d73ea6b.jpg",
                    title:"惠百施（EBISU）日本进口48孔/41孔经典宽头牙刷成人软毛牙刷4支装",
                    price:69,
                    id:6612,
                    },
                    {
                    image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-04/6985ed81729114b70555aa7f98c53216.jpg",
                    title:"德国进口domol洗衣机泡腾片 15g*60块/盒",
                    price:83,
                    id:16879,
                    },
                    {
                    image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/f7bd085c2a0213278e68a69647001206.jpg",
                    title:"SK-II 护肤精华露230ml（神仙水）",
                    price:1350,
                    id:170119,
                    },
                    {
                    image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/a6503fdfb8ad9d22e670bb11004c09f6.jpg",
                    title:"SK-II 赋能焕彩精华露50ml（小红瓶）",
                    price:1150,
                    id:170136,
                    },
                    {
                    image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/2814f618e7e112e329af29817ae28edf.jpg",
                    title:"SK-II 护肤面膜(10片)（前男友面膜）",
                    price:1000,
                    id:170140,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/dabd7a72e935fe241729fd41de96a56f.jpg",
                    title:"兰蔻LANCOME 清滢柔肤水400ml（大粉水）",
                    price:253,
                    id:177256,
                    },
                    {
                    image:"http://gzh.xiaojiangwh.com/uploads/attach/2021/02/20210227/478d7981e306658b02476a22e51f44d2.jpg",
                    title:"日本花王·香皂white天然植物沐浴玫瑰护肤香皂(香型随机130g×3块)",
                    price:59,
                    id:177301,
                    },
                    {
                    image:"http://gzh.xiaojiangwh.com/uploads/attach/2021/08/20210809/afb2e4f110c418d2cc9b5b56efd6bb7c.jpg",
                    title:"欧舒丹乳木果经典护手霜30ml*2支",
                    price:180,
                    id:177303,
                    },
                    {
                    image:"http://gzh.xiaojiangwh.com/uploads/attach/2021/02/26/5f6b4e8d58437150d0cc51a5547f52d0.jpg",
                    title:"滴露Dettol·消毒液1.2L杀菌除螨",
                    price:74,
                    id:177320,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/2955b74d0757919a3fbb701a5114f7df.jpg",
                    title:"花王洗洁精（香型随机） 240ml*3",
                    price:54,
                    id:177343,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/486d7b3c982d7f3a0adfff8e67589b34.jpg",
                    title:"资生堂 可悠然美肌沐浴露 碧野悠悠 绿色550ml",
                    price:56,
                    id:178109,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220524/40ca17611b54d5d7b62b827ef38dc0a9.jpg",
                    title:"日本 LAURIER/乐而雅卫生巾S系列 17厘米*38片",
                    price:34,
                    id:178806,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220530/597dffdd5be404582bf618967b042838.jpg",
                    title:"兰蔻LANCOME 新空气轻垫菁纯粉底液100 13g（菁纯气垫）",
                    price:589,
                    id:179311,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220530/67ec0fd5f59494eb3a44a3c2a80f19cf.jpg",
                    title:"兰蔻LANCOME 肌底精华眼霜15ml",
                    price:267,
                    id:179314,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220530/86e6b0632cf6da6519f8ca2433693266.jpg",
                    title:"兰蔻LANCOME 全新精华肌底液50ml（小黑瓶）",
                    price:651,
                    id:179316,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220530/154856ad4c1bbf6ce844b6bcec171c1a.jpg",
                    title:"科颜氏Kiehl's 亚马逊白泥清洁面膜125ml",
                    price:179,
                    id:179327,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220530/a500cf9788b87597f5bb91b0269519aa.jpg",
                    title:"科颜氏Kiehl's 金盏花舒缓保湿面膜100ml",
                    price:408,
                    id:179330,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220530/26c1cc3583393781ce4d61c3e13269f7.jpg",
                    title:"科颜氏Kiehl's 金盏花植萃爽肤水250ml",
                    price:335,
                    id:179331,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220530/7dc16a652e496153dd3f3dc5e23e4b19.jpg",
                    title:"科颜氏Kiehl's 金盏花植萃爽肤水500ml",
                    price:243,
                    id:179332,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220531/430a2510297ef07d9eeff1d75c9d3560.jpg",
                    title:"海蓝之谜La Mer 修护精萃液150ml（精粹水）",
                    price:1209,
                    id:179379,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220531/67b23c62ac68edd18d2cc22d8a908a2b.jpg",
                    title:"圣罗兰YSL 明彩轻垫粉底液20 SPF35 PA++ 14g（皮革）",
                    price:289,
                    id:179395,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/06/20220617/c85e312878deb28f9b0647a5171d77c7.png",
                    title:"蓝月亮 洗衣液 机洗手洗适用（薰衣草香） 2kg*1瓶+1kg袋*3",
                    price:89,
                    id:179785,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/06/20220621/f3965ce0e7835d1dab157c963cb72586.jpg",
                    title:" 花印水漾洁净洗面奶150g  2支",
                    price:66,
                    id:179812,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/970b6202212281720379668.jpg",
                    title:"JM肌司妍 急救面膜10片/盒",
                    price:68,
                    id:180229,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/95b7020221228171739377.jpg",
                    title:"JM肌司妍 蜜莹润峰胶面膜（黑臻版）10片/盒",
                    price:68,
                    id:180230,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/2fb95202212261558174794.jpg",
                    title:"雅诗兰黛EL 保湿柔肤水400ml（大粉水）",
                    price:385,
                    id:180253,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/1938c202212231007175767.jpg",
                    title:"雅诗兰黛EL 新沁水粉底液60 SPF20/PA+++（1C1）30ml",
                    price:453,
                    id:180268,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/17c9620221208220700844.jpg",
                    title:"全棉时代 纯棉柔巾   6包PPJ21700033",
                    price:89.9,
                    id:180297,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a17d820221208214252838.png",
                    title:"CHANTECLAIR大公鸡管家礼盒5件套洗护套装 油污净清洁剂+洗洁精+洗衣皂+洗衣液+污渍克星 红色礼盒五件套",
                    price:178,
                    id:180298,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/686eb202212231545551328.png",
                    title:"奥妙洗衣液 全自动樱花 熏衣草 洗衣液 瓶装2kg *2",
                    price:71,
                    id:180308,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/52512202212231537307130.jpg",
                    title:"大公鸡管家 意大利进口 衣物清洁洗护用品多功能清洁剂洗衣皂洗衣液家庭清洁 红色礼盒装 4件套（1.5L洗衣液）",
                    price:158,
                    id:180310,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/7f62020221223152028327.jpg",
                    title:"尔木萄Amortals 星空美妆蛋（3蛋+蛋托）",
                    price:48,
                    id:180312,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/4618b202212231507509407.jpg",
                    title:"敷尔佳 医用透明质酸钠修复贴 5片/盒（械字白膜）",
                    price:88,
                    id:180315,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/37896202211101625426283.jpg",
                    title:"心相印卫生系列湿巾80抽*3包",
                    price:45,
                    id:180376,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/9612a202211101045037539.jpg",
                    title:"蓝月亮 1kg茶清+卫诺500g*2+芦荟瓶500g",
                    price:62,
                    id:180379,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/c6ba0202211101158443270.jpg",
                    title:"全棉时代 抗菌棉懒人洗碗巾   2卷 PPQ20700002",
                    price:64,
                    id:180395,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/57237202211091641471503.jpg",
                    title:"蒲地蓝口腔特护牙膏100g   薄荷*2",
                    price:95,
                    id:180400,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/871ba202210241320169576.jpg",
                    title:"柚家厨房纸巾210x220mm，75节，2层，2卷/提，5提/箱厨房纸巾210x220mm，75节，2层，2卷/提，5提/箱",
                    price:57,
                    id:180593,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/f37c1202301091752095723.jpg",
                    title:"欧莱雅精油润发乳400ML",
                    price:43,
                    id:180625,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/6c6ee202301091723578081.jpg",
                    title:"云南白药牙膏（留兰）175*4",
                    price:125,
                    id:180628,
                    },
                    {
                    image:"http://crmeb.xiaojiangwh.com/uploads/attach/2022/08/20220822/10c9725efb94f7484b3a40b4c1576548.jpg",
                    title:"花王（KAO）进口浓缩洗衣液 780ml*2瓶",
                    price:54,
                    id:180651,
                    },
                    {
                    image:"http://crmeb.xiaojiangwh.com/uploads/attach/2022/08/20220819/0ea4ce10aa1f0b3710cfc73b793327e3.jpg",
                    title:"资生堂 芬浓FINO美容液洗发露 550ml+资生堂 芬浓FINO美容液护发素 550ml",
                    price:162,
                    id:180655,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/fd1b8202302161743421108.jpg",
                    title:"迪奥口红新传奇999丝绒3.5g",
                    price:141,
                    id:180760,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/9ea16202302161750531562.jpg",
                    title:"护舒宝未来感极护液体卫生巾10片270mm",
                    price:36,
                    id:180762,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/5612120230216175601343.jpg",
                    title:"护舒宝未来感液体超长夜用卫生巾10片340mm",
                    price:42,
                    id:180763,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/1e427202302161801346074.jpg",
                    title:"美克斯/MKS注氧仪补水仪便携家用美容仪手持纳米喷雾保湿面部水光针高压喷枪NV8088A",
                    price:238,
                    id:180764,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/37b0c202302161734293176.jpg",
                    title:"兰蔻菁纯面霜60ml",
                    price:1224,
                    id:180768,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/c53c1202302161707313902.jpg",
                    title:"阿玛尼唇釉#红管 405",
                    price:155,
                    id:180771,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/602ed202212281728273410.jpg",
                    title:"GIK 火山泥清洁面膜 8g*21枚",
                    price:56,
                    id:180779,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a5b7220230216180509161.jpg",
                    title:"创维（Skyworth）四环变频射频美容仪S5 Pro",
                    price:1039,
                    id:180780,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/47e8a202302201141083367.jpg",
                    title:"德国SIDOL汉高清洁剂不锈钢洗涤剂500ml ",
                    price:84,
                    id:180797,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/7e396202302201128498894.jpg",
                    title:"碧浪 自然清新 洗衣液2kg*2",
                    price:78,
                    id:180798,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/cbdeb202302201112104582.jpg",
                    title:"日本 花王KAO蒸汽眼罩 女士 无香 12片",
                    price:58,
                    id:180800,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/36531202302201108312206.jpg",
                    title:"欧莱雅精油润养洗发水700ml",
                    price:59,
                    id:180801,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/1be4c20230220105650738.jpg",
                    title:"日本 LAURIER/乐而雅棉柔卫生巾夜用安心裤型 5片",
                    price:45,
                    id:180802,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/e30e9202302201050131060.jpg",
                    title:"香奈儿Chanel 香奈儿可可小姐馥郁香水50ml",
                    price:1150,
                    id:180803,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d7660202302201043279237.jpg",
                    title:"香奈儿Chanel 嘉伯丽尔天性香水50ml",
                    price:1150,
                    id:180804,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/9afc5202302201037439817.jpg",
                    title:"后whoo 拱辰享美玉琼隔离乳礼盒3件套(40ml+3.4g)",
                    price:261,
                    id:180805,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/59783202302201021309665.jpg",
                    title:"资生堂Shiseido 新艳阳夏臻效水动力防晒乳50ml（蓝胖子防晒）",
                    price:236,
                    id:180807,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/f33b6202302201013486367.jpg",
                    title:"资生堂Shiseido 安热沙金灿倍护防晒喷雾60ml（新版小金瓶喷雾）",
                    price:156,
                    id:180808,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/cb564202302201001091486.png",
                    title:"修丽可SKINCEUTICALS 维生素CE复合修护精华液30ml",
                    price:1193,
                    id:180809,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/e0bf9202302200954125496.jpg",
                    title:"修丽可SKINCEUTICALS 紧致丰润眼霜14g",
                    price:445,
                    id:180810,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/46c68202302171737223400.jpg",
                    title:"植村秀Shu-uemura 眉笔4g#06（深棕色）",
                    price:201,
                    id:180813,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/30e2c202302171734057649.jpg",
                    title:"植村秀Shu-uemura 植萃舒缓洁颜油 150ml（柚子卸妆油）",
                    price:364,
                    id:180814,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/23731202302171722154974.jpg",
                    title:"蜂花九樽植萃固发防脱洗发水植萃精华 358ml精华素+358ml洗发露",
                    price:119,
                    id:180815,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/dfd54202302171713393445.jpg",
                    title:"纳斯NARS 流光美肌轻透蜜粉 11g（散粉）",
                    price:318,
                    id:180816,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/867d3202302171708525733.jpg",
                    title:"科颜氏Kiehl's 高保湿清爽霜50ml",
                    price:329,
                    id:180817,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/0e5f8202302171617332378.jpg",
                    title:"雅诗兰黛DW粉底液1w1象牙白",
                    price:212,
                    id:180818,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/7b69b202302171607441657.jpg",
                    title:"植村秀Shu-uemura 粉底刷55",
                    price:428,
                    id:180819,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/41ff9202302171524474781.png",
                    title:"香奈儿Chanel 五号香水（经典）35ml（浓香）",
                    price:978,
                    id:180820,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d12a8202302171211276836.jpg",
                    title:"迪奥Dior 真我女士淡香水50ml",
                    price:780,
                    id:180821,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/e1a00202302171152221856.jpg",
                    title:"护舒宝液体敏感肌系列卫生巾16片240mm",
                    price:48,
                    id:180822,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/50c52202302171139102383.png",
                    title:"护舒宝幻彩极护炫色派液体卫生巾量多日14片270mm",
                    price:48,
                    id:180823,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/74d8c202302161811545221.jpg",
                    title:"沃品（WOPOW）无线便携电动磨脚器FM01",
                    price:108,
                    id:180827,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/6e1b4202302171555178733.jpg",
                    title:"敷尔佳 医用透明质酸钠修复贴 5片/盒（械字黑膜）",
                    price:109,
                    id:180828,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/f8b01202210181437309613.jpeg",
                    title:"滴露Dettol 衣物除菌液1.5L（香味随机）",
                    price:48,
                    id:180830,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/dbcad202210241323012064.jpg",
                    title:"柚家湿厕纸130x200mm带盖  40片/包10包",
                    price:69,
                    id:180832,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/ede12202302211556171938.jpg",
                    title:"清扬植觉头皮护理强韧蓬松1+1装380SP+375",
                    price:98,
                    id:180833,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/18fb3202302211550018596.jpg",
                    title:"日本 小林制药消臭元除臭清新剂白桃香 400ml  2瓶",
                    price:57,
                    id:180834,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/eb6e1202302211544218030.jpg",
                    title:"阿道夫精油洗护沐套装500g+500g+300g",
                    price:96,
                    id:180835,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a2c6d202302211604385414.jpg",
                    title:"450g滴露洗手液（滋润）/（植物）*2瓶（香味随机）",
                    price:32,
                    id:180836,
                    }
                    ]
                }, 
                {
                    id: 3,
                    titleInfo: require("@assets/images/funv-title3.png"),
                    list: [
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/8719a20221128103936398.jpg",
                    title:"臻味-2980g环球美果礼盒",
                    price:238,
                    id:253,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2021/01/20210105/7802346fbf4ff26d0c259c3bc6130dee.jpg",
                    title:"臻味 810g天天坚果成人款礼盒",
                    price:133,
                    id:277,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2021/05/20210512/45ecd760559e9b22826e9530579d55b3.jpg",
                    title:"吴裕泰茉莉小白毫花360g   2铁皮圆桶装",
                    price:216,
                    id:6803,
                    },
                    {
                    image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-02/254b1d1607e60b5cbd5202c922e851bc.jpg",
                    title:"山真美 金丝皇菊花茶45g/盒 2盒装",
                    price:45,
                    id:7824,
                    },
                    {
                    image:"https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-02/960c89f4fe7ad753b270d63eb3e84c0c.jpg",
                    title:"伊利金典有机纯牛奶梦幻盖 250mlx10盒",
                    price:72,
                    id:10350,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/cf105c13ac625423c2d20aca0891e2e6.jpg",
                    title:"姚生记500克姚小鲜每日坚果/桶装",
                    price:71,
                    id:177865,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/47737c3f717e08c67b2a1e8f020d9ddf.jpg",
                    title:"伊利安慕希高端畅饮型希腊风味酸奶原味230gx10",
                    price:70,
                    id:177870,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d97e1202302221033198249.jpg",
                    title:"宅而有味螺蛳粉340g*5袋装",
                    price:47,
                    id:178717,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220523/906d3c279568644f0b5e1b0c99bf9c0e.jpg",
                    title:"榴芒一刻 泰国金枕头榴莲冻肉 250g*3盒装 ",
                    price:154,
                    id:178745,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220523/8aa27edf673b565426cb469903b4ec76.jpg",
                    title:"榴芒一刻 榴莲饼200g*2袋装 ",
                    price:29,
                    id:178749,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220524/17a858c8ef876e54eeef4eaef8c0d83b.jpg",
                    title:"中粮山萃三瓶装纯正蜂蜜组合750g（250g*3）",
                    price:77,
                    id:178860,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/07/20220720/48357060f474672495a230f6b8e34271.jpg",
                    title:"黄天鹅可生食鸡蛋20枚电商1kg",
                    price:52,
                    id:179866,
                    },
                    {
                    image:"http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/eed957722b81b9ba2eeb27e4e6e598c5.jpg",
                    title:"蒙牛 特仑苏有机纯牛奶250ml*10盒",
                    price:74,
                    id:179921,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/47ceb20221221111644645.jpg",
                    title:"紫光园紫气迎春清真熟食礼盒2700g",
                    price:280,
                    id:180095,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/7bd3e202211091723378073.jpg",
                    title:"费列罗 榛果威化糖果巧克力礼盒 T24 300g",
                    price:104,
                    id:180103,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/b6a6d202212211501468671.jpg",
                    title:"东来顺 悦享东来2200g",
                    price:307,
                    id:180108,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/817692022120716280258.jpg",
                    title:"鲜禾鲜土鸡蛋60枚",
                    price:110,
                    id:180582,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/aaa90202212231516379555.jpg",
                    title:"鲜禾鲜 草原羊肉塞北礼盒3000g",
                    price:359,
                    id:180583,
                    },
                    {
                    image:"http://crmeb.xiaojiangwh.com/uploads/attach/2022/08/20220819/f3860def69e0302cedeba75d6433b972.jpg",
                    title:"蒙都488g牛肉（手撕）原味",
                    price:144,
                    id:180668,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/49b50202210281523287231.jpeg",
                    title:"沟帮子熏鸡熟食礼盒  华礼1824g",
                    price:248,
                    id:180669,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/136ac202212091643538065.png",
                    title:"好丽友好福气礼盒1264g",
                    price:125,
                    id:180673,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/80246202210131710102279.jpeg",
                    title:"歌帝梵商务尊享巧克力礼盒12颗装 80g",
                    price:189,
                    id:180676,
                    },
                    {
                    image:"http://crmeb.xiaojiangwh.com/uploads/attach/2022/08/20220819/9d140c3cc2b4199e8e6ccc1f58fddcf5.jpg",
                    title:"王小卤虎皮凤爪卤香味200g*2",
                    price:58,
                    id:180677,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/5e399202212071426499113.jpg",
                    title:"【2023款】东来顺百味百顺熟食礼盒2050g",
                    price:313,
                    id:180679,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/63182202301092107161946.jpg",
                    title:"好想你每日缤纷枣795g",
                    price:99,
                    id:180688,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/8d8cb202301092123147799.jpg",
                    title:"皇冠 丹麦曲奇 681g",
                    price:99,
                    id:180690,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a2360202211181144477861.jpg",
                    title:"及养堂银耳羹随手泡15gx12袋*2",
                    price:264,
                    id:180751,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/eeda220221109170752653.jpg",
                    title:"蒙都元气粮礼盒1150g",
                    price:237,
                    id:180753,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/25fb4202212081730042754.jpg",
                    title:"张飞甄香有礼855g礼盒",
                    price:147,
                    id:180754,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/73300202210141107101815.jpeg",
                    title:"鲜禾鲜 牛肉悦享礼盒2500g",
                    price:299,
                    id:180755,
                    },
                    {
                    image:"http://crmeb.xiaojiangwh.com/uploads/attach/2022/08/20220819/ec1a9aa537f245e8851d46e74f7e7f66.jpg",
                    title:"天福号天福豪情熟食礼盒1600g",
                    price:250,
                    id:180756,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/36f1220221223161647257.jpg",
                    title:"宫粮即食燕窝70ml*4瓶 （赠品：蜂蜜100g*1瓶）",
                    price:202,
                    id:180757,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/c4aea202302211638295608.jpg",
                    title:"皇家臻味美国原色开心果500g",
                    price:99,
                    id:180840,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/1559f202302211635008710.jpg",
                    title:"鲜品屋-826g寻味酥点礼盒",
                    price:88,
                    id:180841,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/aec84202302211627489665.jpg",
                    title:"乐巢520奶茶礼盒960g",
                    price:69,
                    id:180843,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/78eb2202302211624181911.jpg",
                    title:"宫粮风味燕窝花胶240g*6碗",
                    price:216,
                    id:180844,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a9170202302211622304403.jpg",
                    title:"宫粮-每日膳食营养粥（女神款） （100g/袋/7袋）",
                    price:31,
                    id:180845,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/1433220230221161458486.jpg",
                    title:"小牛凯西 蛋挞",
                    price:77,
                    id:180846,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/092d9202302211604349951.jpg",
                    title:"同仁堂阿胶糕（桂花味）225g/盒",
                    price:287,
                    id:180847,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/cc128202302211557279623.png",
                    title:"金锣熟食.金锣如意1640g ",
                    price:156,
                    id:180848,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/ae2f4202302211553092715.png",
                    title:"亦佰味猪肉佰礼礼盒3050g",
                    price:239,
                    id:180849,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/6f665202302211548304962.jpg",
                    title:"鲜禾鲜 蜂蜜礼盒B1000g",
                    price:106,
                    id:180850,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a16de202302211545067942.jpg",
                    title:"鲜禾鲜粮辰美景杂粮礼盒3400g",
                    price:102,
                    id:180851,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/15db7202302211539265299.jpg",
                    title:"紫燕贺之宴1679g",
                    price:212,
                    id:180852,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/53c37202302211530572517.jpg",
                    title:"云耕物作低升糖红糖姜茶1袋144g",
                    price:39,
                    id:180854,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/e10d2202302211515245405.jpg",
                    title:"江中彩虹饼干720",
                    price:101,
                    id:180855,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a8a09202302211504203912.jpg",
                    title:"小禾说-娇颜羹礼盒 480g",
                    price:87,
                    id:180856,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/c979b202302211501238573.jpg",
                    title:"圃也家红豆本草鲜炖银耳羹1560g",
                    price:77,
                    id:180857,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/905ca202302211458524785.jpg",
                    title:"圃也家本草鲜炖银耳羹780g（混合口味）",
                    price:52,
                    id:180858,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/97972202302211448139474.jpg",
                    title:"月盛斋天厨佳馔熟食礼盒2200g",
                    price:255,
                    id:180860,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/0c91f202302211442069913.jpg",
                    title:"匠仙渔金汤鲍鱼花胶鸡1500g",
                    price:311,
                    id:180861,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d231820230221143836114.jpg",
                    title:"山真美玫瑰花68g*2罐",
                    price:39,
                    id:180862,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/346f3202302211436428108.jpg",
                    title:"山真美红豆薏米茶72g*2盒",
                    price:35,
                    id:180863,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/bf4ba202302211431037898.jpg",
                    title:"绿帝每日杂粮粥2700g",
                    price:105,
                    id:180864,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d2eee202302211429554815.jpg",
                    title:"绿帝黑五谷礼盒2800g",
                    price:160,
                    id:180865,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/2e2ea202302211428388947.jpg",
                    title:"绿帝山珍献礼菌菇礼盒390g",
                    price:156,
                    id:180866,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/218fa202302211426398379.jpg",
                    title:"倾海之宴鲜炖花胶燕窝礼盒1080g",
                    price:203,
                    id:180867,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/71951202302211424128400.jpg",
                    title:"卡宴合家欢腊味礼盒2600g",
                    price:279,
                    id:180868,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/54a40202302211423091186.jpg",
                    title:"张一元富贵凝香茶叶礼盒400g",
                    price:272,
                    id:180869,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/a8a29202302211417237041.jpg",
                    title:"集味轩坚果礼盒2244g 集萃",
                    price:209,
                    id:180871,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/f0062202302211402543837.jpg",
                    title:"德芙福满臻礼礼盒1049g",
                    price:159,
                    id:180873,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/ed53d202302211149369592.jpg",
                    title:"美心松脆三重奏什锦饼干糕点礼盒331g",
                    price:171,
                    id:180874,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/595dc20230221112556827.jpg",
                    title:"百果园B级-时令柑橘 约：2.7-3公斤",
                    price:105,
                    id:180875,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/d672c202302211115366113.jpg",
                    title:"百果园A级-红宝玉草莓（中果）3斤礼盒装",
                    price:195,
                    id:180876,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/ad25d202302211114085069.jpg",
                    title:"百果园A级-阿克苏蜜心富士约：2.7-3公斤",
                    price:105,
                    id:180877,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/b6f27202302211112557424.jpg",
                    title:"百果园A级-佳沛金奇异果大27# 16个",
                    price:285,
                    id:180878,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/1347d202302211108453547.jpg",
                    title:"德亚 有机全脂高钙牛奶 礼盒200ml*10",
                    price:68,
                    id:180879,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/ca4b720230221110459771.jpg",
                    title:"元朗 蛋卷王 908g",
                    price:78,
                    id:180880,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/bbde2202302211928012190.jpg",
                    title:"野鼬咖啡挂耳情怀四件套",
                    price:195,
                    id:180923,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/66b6b202302211924343224.jpg",
                    title:"十月初五1.315kg招财纳福礼盒",
                    price:159,
                    id:180924,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/17de7202302211748168096.jpg",
                    title:"华都鸡肉休闲食品礼盒B款3650g",
                    price:198,
                    id:180925,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/5746f202210281121174403.jpg",
                    title:"百果园A级-时令红提约：2.7-3公斤",
                    price:184,
                    id:180926,
                    },
                    {
                    image:"https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/zk/cb28e202211181032402962.jpg",
                    title:"好想你  真情意礼礼盒1798g",
                    price:157,
                    id:180927,
                    }
                    ]
                }
            ],
            navTop: null,
            scrollbar: null,
            leaveScroll: 0,
            current: "" //nav当前id
        }
    },
    mounted: function () {
        let dom = this.$refs.six;
        this.getData();
        dom.addEventListener("scroll", debounce(this.onScroll, 100), false);
    },
    updated: function () {
        this.getDom();
    },
    methods: {
        goTo: function () {
            const dom = this.$refs.six;
            dom.scrollTo(0, 0);
            this.mounting = false;
            this.current = this.list[0].id;
        },
        goPage: function () {
            this.$router.push({path: '/'});
        },
        checkNav: function (id) {
            // console.log(id, "nav");
            if (id == this.current) return;
            this.current = id;
            const dom = this.$refs.six;
            for(let i=0; i < this.list.length; i++ ) {
                if (id == this.list[i].id) {
                    dom.scrollTo(0, this.list[i].top);
                }
            }
        },
        onScroll: function (e) {
            let scrol = e.target.scrollTop;
            // console.log(scrol,"监听滚动条");
            this.scrollbar = scrol;
            if (this.navTop && scrol >= this.navTop) { // nav
                this.mounting = true;
            } else {
                this.mounting = false;
            }

            // console.log(scrol, this.navTop,"=navTop")

            this.list.forEach((item)=>{
                if (item.totalHeight >= scrol && scrol >= item.top) {
                    // console.log(item.top,"top", item.totalHeight);
                    this.current = item.id;
                }
            });
        },
        getData: function () {
            //获取数据
            this.current = this.list[0].id;
            //this.$nextTick(()=>)↓
            // this.$nextTick(()=> this.getDom())
            
        },
        getDom: function () {
            // console.log(this.$refs.modul1.offsetHeight, "height")
            this.list.forEach((item)=>{
                item.top = this.$refs[`modulSix${item.id}`] && this.$refs[`modulSix${item.id}`][0] && this.$refs[`modulSix${item.id}`][0].offsetTop;
                item.totalHeight = this.$refs[`modulSix${item.id}`] && this.$refs[`modulSix${item.id}`][0] && (this.$refs[`modulSix${item.id}`][0].offsetTop + this.$refs[`modulSix${item.id}`][0].offsetHeight);
            });
            
            this.navTop = this.$refs.navfn.offsetTop;
            
            
            // console.log(this.$refs.navfn.offsetTop,"this.$refs.navfn.offsetTop");
        }
    },
    deactivated: function () {
        // let dom = this.$refs.six;
        // dom.removeEventListener("scroll", this.onScroll);
    },
    activated: function () {
        const dom = this.$refs.six;
        dom.scrollTo(0, this.scrollbar);
    },
    beforeRouteLeave: function (to, from, next) {
        this.leaveScroll = this.scrollbar;
        next();
    }
}
</script>

<style scoped lang="scss">
.page-wrapper {
}
.banner-wrapper {
    height: 8.72rem;
}
.festivalList-wrapper {
    height: auto;
    background: linear-gradient(#FFD7D2, #FF7E82)
}
.nav-content-title-wrapper {
    height: .8rem;
}
.mounting {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
}
.nav-wrapper {
    height: 1rem;
}
.marTop {
    margin-top: 1rem;
}
.flower-left {
    position: absolute;
    left: 0;
    top: 14rem;
    z-index: -1;
}
.flower-right {
    position: absolute;
    right: 0;
    top: 18rem;
    z-index: -1;
}
.bottom-click {
    margin: 0 auto;
    width: 1.78rem;
}
</style>